'use client'

import { HttpTypes } from "@medusajs/types"
import { TemplateResponse } from "@lib/template/types"
import PuckRenderer from "@/components/puck/PuckRenderer"

interface TemplateProductCardProps {
  product: HttpTypes.StoreProduct
  region: HttpTypes.StoreRegion
  productCardTemplate: TemplateResponse
  countryCode?: string
}

/**
 * Renders a product card using the Puck PRODUCT_CARD template from LaunchStore.
 *
 * The template is component-based: puckData.content holds the card exactly as
 * authored in the editor (ProductImageGallery, ProductTitle, AddToCart, …)
 * with their own props. Rendered with the standard Puck renderer — the
 * product, region and countryCode flow in via context, which the card
 * components read through useProduct()/usePuckContext().
 */
export default function TemplateProductCard({
  product,
  region,
  productCardTemplate,
  countryCode = 'us',
}: TemplateProductCardProps) {
  const puckData = productCardTemplate.puckData

  if (!puckData?.content?.length) {
    return null
  }

  return (
    <div className="w-full max-w-full min-w-0 overflow-hidden">
      <PuckRenderer
        data={{
          ...puckData,
          context: {
            ...(puckData.context || {}),
            product,
            region,
            countryCode,
            // Card mode — product components (gallery, title, variant
            // selector) render compact + link to the product page.
            productCard: true,
          },
        }}
      />
    </div>
  )
}
